// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__CDI-B","title":"AfterFrontImage_title__YYqrD"};